export const POSTCODE_API_URL = 'https://postcode.tech/api/v1';
